import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "../store/slices/authSlice";
import newsReducer from "../store/slices/newsSlice";
import jobReducer from "../store/slices/jobSlice";
import contactReducer from "../store/slices/contactSlice";
import activeJobReducer from "../store/slices/activeJobSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  news: newsReducer,
  job: jobReducer,
  contact: contactReducer,
  active: activeJobReducer,
});

export default rootReducer;
